import React from 'react';
import Orb from './orb';
import './App.css';

function App() {
  return (
    <div className="App">
      <Orb 
        hue={0}
        hoverIntensity={0}
        rotateOnHover={true}
        forceHoverState={false}
      />
    </div>
  );
}

export default App;
